import type { ApiError, GeocodeResponse, LngLat, RouteResponse, RouteType } from '../shared/types';

/**
 * /api（Pages Functions）へのクライアント。
 * ブラウザは外部 API を直接呼ばない。キー・レート制限・プロバイダ切り替えはすべてサーバー側。
 */
export class ApiClientError extends Error {
  constructor(message: string, readonly code: string, readonly status: number) {
    super(message);
  }
}

async function getJson<T>(url: string, signal?: AbortSignal): Promise<T> {
  const res = await fetch(url, { signal, headers: { accept: 'application/json' } });
  const body = (await res.json().catch(() => ({}))) as T | ApiError;
  if (!res.ok) {
    const err = body as ApiError;
    throw new ApiClientError(err.error ?? `HTTP ${res.status}`, err.code ?? 'unknown', res.status);
  }
  return body as T;
}

const fmt = (p: LngLat) => `${p[0].toFixed(6)},${p[1].toFixed(6)}`;

export function fetchRoute(from: LngLat, to: LngLat, type: RouteType = 'fastest', signal?: AbortSignal): Promise<RouteResponse> {
  return getJson(`/api/route?from=${fmt(from)}&to=${fmt(to)}&type=${type}`, signal);
}

/** near: 近い結果を優先するための基準点。細かい位置は送らず、0.1 度（約10km）に丸める */
export function geocode(q: string, near?: LngLat, signal?: AbortSignal): Promise<GeocodeResponse> {
  const nearParam = near ? `&near=${near[0].toFixed(1)},${near[1].toFixed(1)}` : '';
  return getJson(`/api/geocode?q=${encodeURIComponent(q)}${nearParam}`, signal);
}
